import request from '@/utils/request'

// 购物车列表
export function shopCartList(data) {
  return request({
    url: '/proxyApi/findCartList',
    method: 'post',
    data,
  })
}
// del购物车列表
export function delshopCartList(data) {
  return request({
    url: '/proxyApi/delCart',
    method: 'post',
    data,
  })
}